import { PersistedValue } from './PersistedValue';
import { isObject } from './isObject';
export class PersistedValueBuilder {
    static from(storedValue) {
        if (!isObject(storedValue)) {
            return undefined;
        }
        if (!storedValue.storageTimeInSeconds) {
            return undefined;
        }
        if (!storedValue.ttl) {
            return undefined;
        }
        if (!storedValue.version) {
            return undefined;
        }
        if (!storedValue.value) {
            return undefined;
        }
        if (!storedValue.key) {
            return undefined;
        }
        return new PersistedValue(storedValue.key, storedValue.value, storedValue.version, storedValue.ttl, storedValue.storageTimeInSeconds);
    }
    static getDurationInSeconds(duration, unit) {
        switch (unit) {
            case 'second':
                return duration;
            case 'minute':
                return this.getDurationInSeconds(duration * 60, 'second');
            case 'hour':
                return this.getDurationInSeconds(duration * 60, 'minute');
            case 'day':
                return this.getDurationInSeconds(duration * 24, 'hour');
            case 'week':
                return this.getDurationInSeconds(duration * 7, 'day');
            case 'month':
                return this.getDurationInSeconds(duration * 30, 'day');
            case 'year':
                return this.getDurationInSeconds(duration * 365, 'day');
            default:
                return duration;
        }
    }
}
//# sourceMappingURL=PersistedValueBuilder.js.map